import axiosInstance from '../../utils/axiosInstance';
import endpoints from '../../utils/endpoints';
import serializeStrapiParams from '../../utils/serializeStrapiParams';

const find = async (query) => {
  const { data } = await axiosInstance.get(endpoints.discountCodes(), {
    params: query,
    paramsSerializer: (params) => {
      const pairs = serializeStrapiParams(params);
      return pairs.join('&');
    },
  });
  return data;
};

const findOne = async (id) => {
  const sid = String(id);
  if (!id || sid.trim() === '' || sid.startsWith(':')) {
    throw new Error('Discount code ID is required');
  }
  const { data } = await axiosInstance.get(endpoints.discountCodes(sid));
  return data;
};

const create = async (payload) => {
  const body = { data: payload };
  const { data: result } = await axiosInstance.post(endpoints.discountCodes(), body);
  return result;
};

const update = async (id, payload) => {
  if (!id) {
    throw new Error('Discount code ID is required');
  }
  const body = { data: payload };
  const { data: result } = await axiosInstance.put(
    endpoints.discountCodes(id),
    body
  );
  return result;
};

const remove = async (id) => {
  if (!id) {
    throw new Error('Discount code ID is required');
  }
  const response = await axiosInstance.delete(endpoints.discountCodes(id));
  return response?.data;
};

const client = { find, findOne, create, update, remove };

export default client;
